/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListResponse } from '../models/ListResponse';
import type { Settings } from '../models/Settings';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SettingsService {

    /**
     * Get a list of `Settings`
     * @returns any A list of `Settings`.
     * @throws ApiError
     */
    public static listSettings({
page,
size,
filter,
sort,
}: {
/**
 * Page number
 */
page?: number,
/**
 * Number of items per page
 */
size?: number,
/**
 * A filter to apply to the results. Multiple filters can be applied by using the same parameter name multiple times. String must be URL encoded. String follows the format field,operator,value(s),required. Filters can be applied to associations by using `[associatedModel*].[attribute]` as field. If values is an array, which is allowed for e.g. the operators "in", "notIn" etc, the delimiter "|" must be used. "required" is allowed, if a deep filter (= filter on an association) is set. In this case, only entities that have an associated entity are returned. *model name should be written as in the API Response, meaning with lowercase first letter and if need be in plural. `required` is optional
 */
filter?: string,
/**
 * Sorts the results by the given field and order. The format is field:order. The order can be asc or desc. Multiple fields can be sorted by using a comma separated list.
 */
sort?: string,
}): CancelablePromise<(ListResponse & {
data?: Array<Settings>;
})> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/settings',
            query: {
                'page': page,
                'size': size,
                'filter': filter,
                'sort': sort,
            },
        });
    }

    /**
     * Get a specific `Settings`
     * @returns any A single `Settings`.
     * @throws ApiError
     */
    public static getSettings({
id,
}: {
/**
 * ID of the `Settings`
 */
id: string,
}): CancelablePromise<{
data?: Settings;
}> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/settings/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Update a specific `Settings`
     * @returns any A single `Settings`.
     * @throws ApiError
     */
    public static updateSettings({
id,
requestBody,
}: {
/**
 * ID of the `Settings`
 */
id: string,
requestBody: Settings,
}): CancelablePromise<{
data?: Settings;
}> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/settings/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
